import TemplateView from "../../../../TemplateView"
import {HierarchyLevels} from 'constants'
import {HIERARCHY_LEVEL_CLASSES} from '../../../../components/counterCPT/constants'
import CheckboxIcon from '../../../../components/CheckboxIcon'

export default class IndeterminateCustomCheckboxWithMenu extends TemplateView {
    constructor({
        menu = null,
        menuTextsMaps = {},
        onClick = () => {},
        hierarchyLevel = HierarchyLevels.TASK,
    }) {
        super()

        this.onClick = onClick
        this.menu = menu
        this.menuTextsMaps = menuTextsMaps
        this.hierarchyLevel = hierarchyLevel

        this.state = {
            checked: false,
            indeterminate: false,
            disabled: false,
        }

        this.onAnyStatePropertyChanged(['checked', 'indeterminate', 'disabled'], ({checked, indeterminate, disabled}) => {
            this.getEl().toggleClass('indeterminate', indeterminate)
            this.getEl().toggleClass('disabled', disabled)
            this.checkbox.setState({
                checked,
                indeterminate,
                disabled,
            })
        })
    }

    templateHtml() {
        return "<div class='indeterminateCustomCheckboxWithMenu <%-hierarchyLevelClass%>'>" +
               "  <div class='checkboxPlaceholder'></div>" +
               "  <div class='icon'></div>" +
               "</div>"
    }

    templateModel() {
        return {
            hierarchyLevelClass: HIERARCHY_LEVEL_CLASSES[this.hierarchyLevel],
        }
    }

    afterRender() {
        this.checkbox = new CheckboxIcon().init(this.find('.checkboxPlaceholder'))

        this.$el.click((e) => {
            e.stopPropagation()

            if (this.state.disabled)
                return

            if (this.state.indeterminate) {
                this.menu.setCallback((checked) => {
                    this.onClick(checked)
                    this.menu.hide()
                })

                this.menu.setOnHideCallback(() => {
                    this.getEl().removeClass('pressed')
                })

                this.menu.setState({
                    hierarchyLevel: this.hierarchyLevel,
                    assignTextsMap: this.menuTextsMaps.assignTextsMap,
                    revokeTextsMap: this.menuTextsMaps.revokeTextsMap,
                })
                this.menu.showAt(this.find('.checkboxPlaceholder'), {})
                this.getEl().addClass('pressed')
            } else {
                this.onClick(!this.state.checked)
            }
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/IndeterminateCustomCheckboxWithMenu.js